import React from 'react';
import ReactDOM from 'react-dom';
import Component from './Component';

export default class CKEditor extends Component {

	static defaultProps = {
		height: 150,
		width: '100%',
		plugins: "resize,font,colorbutton,pastefromword,colordialog,image,basicstyles,button,contextmenu,clipboard,enterkey,indent,link,list,table,format,sourcearea,toolbar,undo,justify,removeformat,wysiwygarea",
		toolbar: [["Bold","Italic","-","NumberedList","BulletedList","-","Link","Unlink", '-', 'Source']]
	};

	constructor(props) {
		super(props);
		this.data = props.value;
	}

	componentDidMount() {
		const config = {
			"height": this.props.height,
			"width": this.props.width,
			allowedContent: true,
			"plugins": this.props.plugins,
			"toolbar": this.props.toolbar
		};
		if (!this.ckeditor) {
			this.ckeditor = CKEDITOR.replace(ReactDOM.findDOMNode(this), config);
			this.updateEditor();
			this.ckeditor.on('change', () => {
				if (this.ckeditor) {
					this.data = this.ckeditor.getData();
					this.handleChange();
				}
			});
			this.ckeditor.on('instanceReady', () => {
				if (this.ckeditor && this.props.autoFocus) {
					this.ckeditor.focus();
				}
				setTimeout(() => {
					this.updateEditor();
				}, 100)
			});
		}
	}

	focus() {
		if (this.ckeditor) {
			this.ckeditor.focus();
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.value != nextProps.value && this.data != nextProps.value) {
			this.data = nextProps.value;
			this.updateEditor();
		}
	}

	componentWillUnmount() {
		this.destroyCkeditor();
	}

	shouldComponentUpdate(nextProps) {
		return false;
	}

	updateEditor() {
		this.ckeditor && this.ckeditor.setData(this.data, {callback: () => {
		},	noSnapshot : true});
	}

	destroyCkeditor() {
		if (this.ckeditor) {
			this.data = this.ckeditor.getData();
			this.ckeditor.destroy();
			this.ckeditor = null;
		}
	}

	handleChange() {
		if (this.props.onChange) {
			this.props.onChange(this.data);
		}
		if (this.props.onBlur) {
			this.props.onBlur(this.data);
		}
	}

	render() {
		return (
			<textarea></textarea>
		);
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/CKEditor.js